import { motion } from 'framer-motion'
import styled from 'styled-components/macro'

import { Overlay, styleReset } from 'styles/misc'
import { mq, ScreenSize } from 'styles/mq'
import { theme } from 'styles/theme'

export const PeopleContainer = styled(motion.div)`
  position: fixed;
  bottom: 0;
  right: 0;
  max-width: 100vw;
  height: calc(100vh - var(--header-height) - var(--timeline-height));
  padding: 0;
  color: white;
  background-color: ${theme.colors.accent.primary};

  &::after {
    ${Overlay}
    content: '';
    display: block;
    pointer-events: none;
    background: linear-gradient(
      to top,
      ${theme.colors.accent.primary}cc,
      ${theme.colors.accent.primary}00,
      ${theme.colors.accent.primary}cc
    );
    z-index: 10;
  }

  ${mq.medium} {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  ${mq.large} {
    padding-left: 4rem;
    padding-right: calc(
      var(--container-spacing) + 50vw - (${ScreenSize.LG / 20}rem)
    );
  }
`

export const CloseButton = styled.button`
  ${styleReset}
  position: absolute;
  top: 2rem;
  right: 2rem;
  cursor: pointer;
  z-index: 100;

  ${mq.large} {
    top: 2.5rem;
    right: calc(var(--container-spacing) + 50vw - (${ScreenSize.LG / 20}rem));
  }
`

export const List = styled.ul`
  display: block;
  width: 38rem;
  height: 100%;
  padding: 3rem 4rem;
  margin: 0;
  list-style: none;
  font-size: 1.8rem;

  .swiper {
    height: 100%;
  }

  .swiper-slide {
    height: auto;
  }
`

export const Item = styled.div`
  margin: 0;
  padding: 1.25rem 0;
  opacity: 0.8;
  transition: opacity 0.4s;

  .swiper-slide-active & {
    opacity: 1;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`

export const Name = styled.span`
  display: block;
  font-size: 2.1rem;
  line-height: 2.1rem;
  font-weight: bold;
  margin-bottom: .7rem;

  &::before {
    content: '';
    display: inline-block;
    vertical-align: baseline;
    width: 0.9em;
    height: 0.9em;
    margin: 0 0.1em -0.14em 0;
    background-color: currentColor;
    mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.96191 16.0889H2.46191V15.3389C2.46522 12.4407 4.81379 10.0922 7.71191 10.0889H10.7119C13.61 10.0922 15.9586 12.4407 15.9619 15.3389V16.0889H14.4619H13.7119C11.7442 16.0889 12.782 16.0913 10.7119 16.0889H7.71191C7.3151 16.0893 7.10121 16.0896 6.99445 16.0898C6.92734 16.09 6.82335 16.0901 6.99445 16.0898C7.10391 16.0895 7.11521 16.0889 5.67406 16.0889H3.96191Z' fill='currentColor'/%3E%3Cpath d='M5.46191 5.58887C5.46191 7.65993 7.14085 9.33887 9.21191 9.33887C11.282 9.33639 12.9594 7.65891 12.9619 5.58887C12.9619 3.5178 11.283 1.83887 9.21191 1.83887C7.14085 1.83887 5.46191 3.5178 5.46191 5.58887Z' fill='currentColor'/%3E%3C/svg%3E%0A");
  }
`
